import { jsx as _jsx } from "react/jsx-runtime";
import App from './App';
import { loadHostedPreset } from './lib/settingsStore';
import './styles.css';
import { ThemeProvider } from './theme/ThemeProvider';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
const chunkFilename = __webpack_get_script_filename__;
__webpack_get_script_filename__ = (chunkId) => `${chunkFilename(chunkId)}?_=${process.env.EPHEMON_BUILD_TIMESTAMP}`;
void loadHostedPreset().then(() => {
    const rootElement = document.getElementById('root');
    if (rootElement) {
        createRoot(rootElement).render(_jsx(StrictMode, { children: _jsx(ThemeProvider, { children: _jsx(App, {}) }) }));
    }
    else {
        console.error('Unable to locate element with id "root"');
    }
});
